import React, { Component } from "react";

import { Link } from "react-router-dom";

import PropTypes from 'prop-types';

export default class Noticia extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    
    this.state = {
    }

  }
  
  newsClicked = () => {
    this.context.router.history.push(
      "/noticias_e_eventos/" + this.props.noticia.identifier
    );
  };

  render() {
    const url = "/noticia/" + this.props.noticia.title;

    return (
      <div className="col-12 col-md-4 ">
        <div onClick={this.newsClicked} className="noticia box-shadow">
          <div className="imagem-noticia">
            <img alt="" src={this.props.noticia.mainPhoto} />
          </div>
          <div className="detalhes-noticia">
            <h3>{this.props.noticia.title}</h3>
            <p>{this.props.noticia.date}</p>
            <Link to={url}>Ver mais ></Link>
          </div>
        </div>
      </div>
    );
  }
}
